import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: 'img[tdWbModalNotificationImage]',
  host: {
    '[src]': 'fullSrc()',
    '[attr.aria-hidden]': 'true'
  }
})
export class ModalNotificationImageDirective {
  readonly src = input.required<string>();
  readonly fullSrc = computed(() => `assets/images/modal-notification/${this.src()}`);
}
